'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chair';
var width = 448;
var height = 512;
var aliases = [129681];
var unicode = 'f6c0';
var svgPathData = 'M304 16l0 240-16 0 0-240-56 0 0 240-16 0 0-240-56 0 0 240-16 0 0-240L80 16l0 240-16 0L64 16 64 0 80 0 368 0l16 0 0 16 0 240-16 0 0-240-64 0zM16 368l416 0 0-12.2L406.1 304 41.9 304 16 355.8 16 368zM0 368l0-16 32-64 384 0 32 64 0 16 0 16-16 0-32 0 0 120 0 8-16 0 0-8 0-120L64 384l0 120 0 8-16 0 0-8 0-120-32 0L0 384l0-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChair = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;